import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ReactNode } from 'react';

interface CustomDialogProps {
    cancelLabel?: string;
    confirmLabel?: string;
    content?: { body: ReactNode; title: ReactNode | string };
    disableBackdropDismiss?: boolean;
    disabled?: boolean;
    hideActions?: boolean; // new: suppress default Cancel/Confirm buttons
    hideCancel?: boolean;
    onClose: () => void;
    onConfirm?: () => void; // optional when actions hidden
    open: boolean;
}

function CustomDialog(props: Readonly<CustomDialogProps>) {
    const {
        cancelLabel = 'Cancel',
        confirmLabel = 'Confirm',
        content = {
            body: 'Are you sure you want to proceed with this action?',
            title: 'Confirmation Dialog',
        },
        disableBackdropDismiss = false,
        disabled,
        hideActions = false,
        hideCancel = false,
        onClose,
        onConfirm,
        open,
    } = props;

    const { body, title } = content;

    const displayTitle = title || 'Confirmation';
    const displayBody = body || 'Are you sure you want to proceed with this action?';

    return (
        <Dialog
            onClose={disableBackdropDismiss ? undefined : onClose}
            open={open}
            slotProps={{ paper: { sx: { width: '100%' } } }}
        >
            <DialogTitle>{displayTitle}</DialogTitle>
            <DialogContent>{displayBody}</DialogContent>
            {hideActions ? null : (
                <DialogActions>
                    {!hideCancel && (
                        <Button color="primary" onClick={onClose} variant="outlined">
                            {cancelLabel}
                        </Button>
                    )}
                    <Button
                        disabled={disabled}
                        onClick={onConfirm}
                        sx={{ backgroundColor: 'primary.main' }}
                        variant="contained"
                    >
                        {confirmLabel}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}

export default CustomDialog;
